module.exports = __webpack_public_path__ + "img/8.fdafa6dd.jpg";